import { render, staticRenderFns } from "./NewCustomerModal.vue?vue&type=template&id=477edf2a&"
import script from "./NewCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./NewCustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports